module.exports = __webpack_public_path__ + "img/slide3.2ce6cd17.jpg";